// Single source of truth for the buyable token packages. The amount (in cents)
// and token count live here on the server side of the contract: the client only
// ever sends a package *id*, and the checkout route looks up the real price and
// token amount here — never trusting any amount from the client.

export interface TokenPackage {
  id: string;
  tokens: number;
  price: string; // display string
  amountCents: number; // charged amount, authoritative
}

export const TOKEN_PACKAGES: TokenPackage[] = [
  { id: "tokens_100", tokens: 100, price: "$0.99", amountCents: 99 },
  { id: "tokens_500", tokens: 500, price: "$3.99", amountCents: 399 },
  { id: "tokens_1500", tokens: 1500, price: "$9.99", amountCents: 999 },
];

export const TOKEN_PACKAGE_MAP: Record<string, TokenPackage> = Object.fromEntries(
  TOKEN_PACKAGES.map((p) => [p.id, p]),
);
